// extracted by mini-css-extract-plugin
module.exports = {"trials-per-page":"trial-per-page_trials-per-page__GCKFS"};